import React,{useState} from 'react';

import {useStripe, useElements, PaymentElement} from '@stripe/react-stripe-js';

const StripeFrame = (props) => {
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState(false);
  const hotelId = props.hotelId;
  const tracking = props.tracking;
  const hotelCode = props.hotelCode;
  props.callbackRegister( () => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return null;
    }
    const domain = process.env.URLTPV_ENVIROMENT;
    const url = domain + '/api/hotels/'+hotelId+'/cms/redirect_3d_secure/'+hotelCode+'-'+tracking;

    return stripe.confirmSetup({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: url,
      },
    }).then((result)=>{
      if(result.error) {
        setErrorMessage(result.error.message);
        return false;
      } else {
        return true;
      }

    }).catch((error)=> {
      setErrorMessage(error.message)
    });
  });

  return (
    <div id={'stripeIframe'} >
      <PaymentElement />
      {errorMessage && <div>{errorMessage}</div>}
    </div>
  )
};

export default StripeFrame;